module.exports = __webpack_public_path__ + "img/login-erp.f5a70a35.svg";